import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, SecurityContext, ViewChild } from '@angular/core';
import { ContractService } from '../services/contract.service';
import { NotifierService } from 'angular-notifier';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import { saveAs } from 'file-saver';
// import html2pdf from 'html2pdf.js';
import { ApiRequestService } from 'src/app/services/api-request/api-request.service';
import { MatDialog } from '@angular/material/dialog';
import { ResignConfirmationDialogComponent } from '../pop-ups/resign-confirmation-dialog/resign-confirmation-dialog.component';


@Component({
  selector: 'app-contract-preview',
  templateUrl: './contract-preview.component.html',
  styleUrls: ['./contract-preview.component.scss']
})
export class ContractPreviewComponent implements OnInit, OnDestroy, AfterViewInit {
  public accessRoles: any;
  public uuid:string='';
  public selectedVersion:string='';
  public prevSignedVersion:string='';
  public contractPreviewDetails:any={};
  public previewSafeInnerHtml:SafeHtml='';
  public previewSafeInnerHtmlCopy:SafeHtml='';
  public isReadandAcceptContract:boolean = false; 
  public isDiscardPreSignedVersion:boolean = false; 
  public isContractSigned:boolean = false; 
  public isShowAcceptAndSign:boolean = false; 
  public isPdfLoaded:boolean = false; 
  public fileURL: string = "";
  public fileName: string = '';
  public totalContractPages = 0


  // private observer!: MutationObserver;
  counter = 0;
  private intervalId: any;

   httpPostOptionsFile = {
    withCredentials: true
  };

  // @ViewChild('pdfContent', { static: false }) pdfContent!: ElementRef;
  @ViewChild('contractdoc', { static: false }) contractdoc!: ElementRef;
  @ViewChild('hiddenContainer') hiddenContainer!: ElementRef;

  @ViewChild('pdfIframe') pdfIframe!: ElementRef<HTMLIFrameElement>;
  @ViewChild('scrollWrapper') content!: ElementRef<HTMLDivElement>;
// @ViewChild('pdfIframe') iframe!: ElementRef<HTMLIFrameElement>;

  constructor(
    public contractService: ContractService,
    private notifier:NotifierService,
    private router: Router,
    private activaterRoute:ActivatedRoute,
    public sanitizer:DomSanitizer,
    private apiRequest: ApiRequestService,
    private dialog: MatDialog
  ) {
    this.accessRoles = JSON.parse(localStorage.getItem('access'));
    this.uuid = this.activaterRoute.snapshot.params['uuid'];
  }
  ngAfterViewInit(): void {


  }

 
  //  private resizeIframe() {
  //   const iframeEl = this.pdfIframe.nativeElement;
  //   const doc = iframeEl.contentDocument || iframeEl.contentWindow?.document;
  //   if (!doc) return;

  //   const height = Math.max(
  //     doc.body.scrollHeight,
  //     doc.documentElement.scrollHeight
  //   );
  //   iframeEl.style.height = height + 'px';
  // }
  
  ngOnDestroy(): void {
    this.fileURL = '';
    this.fileName = '';
    this.selectedVersion = '';
    this.contractService.isLoading = false;
    this.stopInterval();
    // this.observer?.disconnect();
  }

  ngOnInit(): void {
    this.selectedVersion = this.contractService.contractVersionList && this.contractService.contractVersionList[0] ? this.contractService.contractVersionList[0]+'' : '';
    this.getContractPreview();
    // this.fileURL = this.getTrustedUrl(this.fileURL);
  }

  

  getContractPreview(){
    this.isPdfLoaded = false;
    let query = {"version":this.selectedVersion,"uuid":this.uuid};
    this.contractService.isLoading = true;
    this.contractService.getContractPreview(query).subscribe((result) => {
      if (result["status"] == 1) {
        this.contractService.cid = result["cid"];

        this.isShowAcceptAndSign = result['is_show_accept_sign'] ? result['is_show_accept_sign'] : false;
        this.isContractSigned = result['signed'] ? result['signed'] : false;
        this.contractPreviewDetails = result['data'];
        this.prevSignedVersion = result['prevSignedVer'] ? result['prevSignedVer'] : '';
        this.isDiscardPreSignedVersion = result['discardPreSignedVersion'] ? result['discardPreSignedVersion'] : false;
        this.contractService.contractVersionList = result['versions'].map((item) => item +'');
        this.selectedVersion = this.selectedVersion && this.selectedVersion !="" ? this.selectedVersion : result['versions'][0] +'';
        this.totalContractPages = result['pageCount'];
        this.fileURL = encodeURIComponent(this.contractPreviewDetails['file_url']);
        // this.contractService.isLoading = false;
        this.startInterval();
        // this.fileURL = encodeURIComponent("https://research-crownit.s3.ap-southeast-1.amazonaws.com/contracts/C-000136/1_C-000136.pdf?AWSAccessKeyId=AKIAIBN57CG5R3WYJHCQ&Expires=1750228356&Signature=1xf2NrdYcJqeO8GTN%2FpsNLiuCRE%3D")
        // this.fileURL = encodeURIComponent("https://research-crownit.s3.ap-southeast-1.amazonaws.com/contracts/C-000059/1_C-000059.pdf?AWSAccessKeyId=AKIAIBN57CG5R3WYJHCQ&Expires=1750224733&Signature=HKX6AVvWYf8uiJcsJyTNEA2o700%3D");

        // this.previewSafeInnerHtml = this.sanitizer.bypassSecurityTrustHtml(this.contractPreviewDetails['inner_html']);
        // this.previewSafeInnerHtmlCopy = this.contractPreviewDetails['inner_html'];



      }else{
        this.notifier.notify('error','Something went wrong !');
        this.contractService.isLoading = false;
      }
    }, err => {
      this.notifier.notify('error','Something went wrong !');
      this.contractService.isLoading = false;
    })
  }

  // checkIframeCintentLoaded() {
  //   const iframe = this.pdfIframe.nativeElement;
  //   const iframeDocument = iframe.contentDocument || iframe.contentWindow?.document;

  //   if (iframeDocument) {
  //     this.observer = new MutationObserver(() => {
  //       console.log('Iframe content changed');
  //       // Logic to handle content change
  //     });

  //     this.observer.observe(iframeDocument, { childList: true, subtree: true });
  //   }
  // }

  // onSignContract(){
  //   this.contractService.onSignContract(this.uuid);
  // }

  // resetContractPreview(){
  //   this.contractService.isLoading = true;
  //   let query = {"version":this.selectedVersion,"uuid":this.uuid};
  //   this.contractService.getContractPreview(query).subscribe((result) => {
  //     if (result["status"] == 1) {
  //       this.contractService.cid = result["cid"];
  //       this.isShowAcceptAndSign = result['is_show_accept_sign'] ? result['is_show_accept_sign'] : false;
  //       this.isContractSigned = result['signed'] ? result['signed'] : false;
  //       this.contractPreviewDetails = result['data'];
  //       this.prevSignedVersion = result['prevSignedVer'] ? result['prevSignedVer'] : '';
  //       this.isDiscardPreSignedVersion = result['discardPreSignedVersion'] ? result['discardPreSignedVersion'] : false;
  //       this.contractService.contractVersionList = result['versions'].map((item) => item +'');
  //       this.selectedVersion = this.selectedVersion && this.selectedVersion !="" ? this.selectedVersion : result['versions'][0] +'';
  //       this.totalContractPages = result['pageCount'];
  //       this.fileURL = encodeURIComponent(this.contractPreviewDetails['file_url']);
  //       this.contractService.isLoading = false;
  //       this.startInterval();
  //       // this.previewSafeInnerHtml = this.sanitizer.bypassSecurityTrustHtml(this.contractPreviewDetails['inner_html']);
  //       // this.previewSafeInnerHtmlCopy = this.contractPreviewDetails['inner_html'];
  //       this.generateSignedPDF();
  //     }else{
  //       this.notifier.notify('error','Something went wrong !');
  //       this.contractService.isLoading = false;
  //     }
  //   }, err => {
  //     this.notifier.notify('error','Something went wrong !');
  //     this.contractService.isLoading = false;
  //   })
  // }
  
  onSignContract(){
    if(this.isReadandAcceptContract){
      if (this.isDiscardPreSignedVersion) {
        this.openReSignConfirmationDialog();
      }else{
        let body = {"uuid":this.uuid,"signed":true,"version":this.selectedVersion};
        this.contractService.signContract(body).subscribe((result) => {
          if (result["status"] == 1) {
            this.notifier.notify('success',result["message"]);
            // this.notifier.notify('success','Contract signed successfully !');
            this.isContractSigned = true;
            // this.resetContractPreview();
            this.getContractPreview();
          }else if (result["status"] == 2) {
            this.notifier.notify('success',result["message"]);
            this.getContractPreview();
          }else{
            this.notifier.notify('error',result["message"]);
          }
        }, err => {
          this.notifier.notify('error','Something went wrong !');
        })
      }
    }else{
      // this.notifier.notify('error','Please read & accept the COS');
      this.notifier.notify('error','Scroll till the bottom to read & accept the COS');
    }
  }

  onVersionChange(version){
    this.selectedVersion = version;
    this.isReadandAcceptContract = false;
    this.getContractPreview();
  }

  onAcceptContract(){
    this.isReadandAcceptContract = !this.isReadandAcceptContract;
  }
// original

  downloadFile(url) {
    const data = url;
    this.fileName = 'contract_'+this.contractService.cid
    let ahref: HTMLElement = document.getElementById("downloadFIleURL");
    ahref.setAttribute("href", url);
    ahref.setAttribute("target", "_blank");
    ahref.setAttribute(
      "download",
      this.fileName+'.pdf'
    );
    this.contractService.isLoading = false;
    ahref.click();
  }

  onDownloadClick(){
    this.contractService.isLoading = true;
    let query = {"version":this.selectedVersion,"uuid":this.uuid};
    this.contractService.getContractDownloadUrl(query).subscribe((result) => {
      if (result["status"] == 1) {
        this.downloadFile(result['url']);
      }else{
        this.notifier.notify('error','Something went wrong !');
        this.contractService.isLoading = false;
      }
    }, err => {
      this.notifier.notify('error','Something went wrong !');
      this.contractService.isLoading = false;
    })

  }


  // onDownloadClick1(){
  //   const newDiv = document.createElement('div');
  //   newDiv.innerHTML = this.previewSafeInnerHtmlCopy as string;

  //   // Remove all elements with class "hr-page-break"
  //   newDiv.querySelectorAll('.hr-page-break').forEach(el => el.remove());

  //   // Append the new div to the hidden container
  //   this.hiddenContainer.nativeElement.appendChild(newDiv);
  //   const element = this.contractdoc.nativeElement.innerHTML;
  //   if (element) {
      
  //     const options = {
  //       margin:       0.5,
  //       filename:     'contract_'+this.contractService.cid+'.pdf',
  //       image:        { type: 'jpeg', quality: 0.98 },
  //       html2canvas:  { useCORS: true, scale: 3 },
  //       jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' },
  //       pagebreak:    { mode: ['avoid-all', 'css', 'legacy'] }
  //     };
  
  //     html2pdf().set(options).from(element).save();
  //     newDiv.remove();
  //   }
  // }

  // generateSignedPDF(): void {
  //   const newDiv = document.createElement('div');
  //   newDiv.innerHTML = this.previewSafeInnerHtmlCopy as string;
  //   newDiv.querySelectorAll('.hr-page-break').forEach(el => el.remove());
  //   this.hiddenContainer.nativeElement.appendChild(newDiv);

  //   const element = this.contractdoc.nativeElement.innerHTML;
  //   if (element) {
  //     const options = {
  //       margin: 0.5,
  //       filename: 'contract_' + this.contractService.cid + '.pdf',
  //       image: { type: 'jpeg', quality: 0.98 },
  //       html2canvas: { useCORS: true, scale: 3 },
  //       jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
  //       pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
  //     };

  //     html2pdf().set(options).from(element).toPdf().get('pdf').then((pdf: any) => {
  //       const pdfData = pdf.output('arraybuffer');
  //       const pdfBlob = new Blob([pdfData], { type: 'application/pdf' });

  //       // Save the PDF locally
  //       // saveAs(pdfBlob, options.filename);

  //       // Send the PDF to the server
  //       this.uploadPdf(pdfBlob);
  //     });

  //     newDiv.remove();
  //     // this.getContractPreview();
  //   }
  // }

  uploadPdf(pdfBlob: Blob): void {
    let input = new FormData();
    // console.log('formData:', input);
    let options: any = {};
    input.append('contractPdf', pdfBlob, ''+this.selectedVersion +"_"+ this.contractService.cid+'.pdf');
    options['method'] = 'POST';
    options['relativeUrl'] = '/v2/contract/signedPdf/'+this.uuid;
    options['body'] = input ? input : {};
    options['options'] = {}; 
    options['options']['httpOptions'] = this.httpPostOptionsFile;
    options['options']['httpOptions']['reportProgress'] = true;
    options['options']['httpOptions']['observe'] = "events";

    this.apiRequest.httpCallForFileUpload(options, (response) => {
      if (response.progress !== undefined) {
        // console.log("pogress in api ===> ",response.progress);
      } else if (response.response) {
        console.log("pogress in api ===> ",response.response);
        // this.emitFileUploadRepoResponse.emit({result: response.response });
      }else{
        this.notifier.notify('error', 'Internet connectivity issue. Please check your connection & try again.');
        this.contractService.isLoading = false;
      }
      
    });

    

  // this.http.post('/api/upload-pdf', formData, {
  //     headers: new HttpHeaders(),
  //     responseType: 'json'
  //   }).subscribe(
  //     response => console.log('PDF uploaded successfully', response),
  //     error => console.error('Error uploading PDF', error)
  //   );
  }

  openReSignConfirmationDialog(): void {
      const dialogRef = this.dialog.open(ResignConfirmationDialogComponent, {
        width: '500px',
        height: '250px',
        disableClose :true,
        data:{
          cid:this.contractService.cid,
          uuid:this.uuid,
          selectedVersion:this.selectedVersion,
          prevVersion:this.prevSignedVersion
        }
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result && result === "confirmed") {
          this.isDiscardPreSignedVersion = false;
          this.onSignContract();
          // console.log('Dialog closed with result:', result);
        }
      });
    }

  contentLoaded(event) {
    // console.log('Content loaded:', event);
    let pageHeight = 1045;
    // let totalPages = 3;
    let totalContentHeight = pageHeight * this.totalContractPages;
    this.pdfIframe.nativeElement.style.height = totalContentHeight+'px'; 
    this.isPdfLoaded = true;
    this.contractService.isLoading = false;
    // this.pdfIframe.nativeElement.style.height = '4000px'; 
    this.stopInterval();
  }

  reloadIframe(): void {
    const iframe = this.pdfIframe.nativeElement;
    const currentSrc = iframe.src;
    iframe.src = ''; // Temporarily clear the src
    iframe.src = currentSrc; // Reset to original src to reload
    this.scrollToTargetID('pdf-top');
  }

  startInterval() {
    // prevent multiple intervals
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.intervalId = setInterval(() => {
      this.reloadIframe();
      this.counter++;
      // console.log('Iframe reloaded:', this.counter);
    }, 10000);
    // console.log('Interval started:', this.intervalId);
  }

  stopInterval() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
      this.contractService.isLoading = false;
    }
  }

  scrollToTargetID(targetId: string) {
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }
    }

}
